import { FC } from 'react'

interface IconVenmoProps {
  className?: string
}
export const IconVenmo: FC<IconVenmoProps> = ({ className }) => {
  return (
    <svg className={className} viewBox="0 0 12 11" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M2.8724 0.34375C1.59081 0.34375 0.539062 1.3955 0.539062 2.67708V8.51042C0.539062 9.792 1.59081 10.8438 2.8724 10.8438H8.70573C9.98731 10.8438 11.0391 9.792 11.0391 8.51042V2.67708C11.0391 1.3955 9.98731 0.34375 8.70573 0.34375H2.8724ZM2.8724 1.51042H8.70573C9.35731 1.51042 9.8724 2.0255 9.8724 2.67708V8.51042C9.8724 9.162 9.35731 9.67708 8.70573 9.67708H2.8724C2.22081 9.67708 1.70573 9.162 1.70573 8.51042V2.67708C1.70573 2.0255 2.22081 1.51042 2.8724 1.51042ZM5.0599 2.53125L2.94531 2.82292L3.89323 8.65625H6.29948C10.0182 3.55208 8.34115 2.53125 8.34115 2.53125C8.34115 2.53125 6.88281 2.82292 6.44531 2.89583C7.10156 4.57292 5.57031 6.76042 5.57031 6.76042L5.0599 2.53125Z"
        fill="black"
      />
    </svg>
  )
}
